import { Container } from "../../components/atoms/container/Container";
import { Text } from "../../components/atoms/text/Text";
import { Flex } from "../../components/molecules/flex/Flex";
import { AssessmentResult } from "../../components/organisms/assessmentResult/AssessmentResult";
import { TicketBasicDetWrapper } from "../../components/organisms/ticketBasicDetWrapper/TicketBasicDetWrapper";
import style from "./ticketHandlingPart2.module.scss";
import { useTicketHandlingPart2 } from "../../hooks/useTicketHandlingPart2/UseTicketHandlingPart2";
import { Ambulance } from "../../components/organisms/logisticsAmbulanceDoctorTab/LogisticsAmbulanceDoctorTab";
import { Button } from "../../components/atoms/button/Button";
import { UseGetStoreData } from "../../hooks/getStoreData/UseGetStoreData";
import { useState } from "react";
import { DoctorConsult } from "../../components/organisms/doctorConsult/DoctorConsult";
import { Icon } from "../../components/icon/Icon";


export const TicketHandlingPart2 = () => {
  const {
    handleBookAmbulance,
    handleCloseTicket,
    handleDemoCloseTicket,
    getPatientDropLocation,
    getPatientPickupAddress,
    getPatientPickupCity,
    getTicketStatus,
    pickupLocationLabel,
    isTicketDemo,
  } = useTicketHandlingPart2();
  const { getTicketMedicalStatus } = UseGetStoreData();
  const isAmbulanceRequired = getTicketMedicalStatus?.isAmbulanceRequired === "Yes";
  const isDoctorRequired = getTicketMedicalStatus?.isDoctorConsultationRequired === "Yes";
  const defaultTab = isDoctorRequired ? "doctor" : "ambulance";
  const [activeTab, setActiveTab] = useState(localStorage.getItem("currentTab") || defaultTab);
  const [isLogisticsOpen, setIsLogisticsOpen] = useState(getTicketStatus !== "completed");
  // Helper function to set active tab and save to localStorage
  // console.log(localStorage.getItem("currentTab"))
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    localStorage.setItem("currentTab", tab);
  };

  return (
    <TicketBasicDetWrapper>
      <Container>
        <AssessmentResult />
      </Container>
      <Container className={style.logistics_wrapper}>
        {/* Tab Navigation with Chevron */}
        <Container className={style.logistics_header} onClick={() => setIsLogisticsOpen(!isLogisticsOpen)}>
          <Flex className={style.flex}>
            {isDoctorRequired && <div
              className={style.operation_wrapper}
              onClick={(e) => { e.stopPropagation(); handleTabChange("doctor"); }}
            >
              <Text
                className={
                  activeTab === "doctor"
                    ? style.tab_heading
                    : style.heading_operation
                }
                text="Doctor Consultation"
              />
            </div>}

            {/* Show Ambulance tab only if ambulance is required */}
            {isAmbulanceRequired && (
              <div
                onClick={(e) => { e.stopPropagation(); handleTabChange("ambulance"); }}
                className={style.operation_wrapper}
              >
                <Text
                  className={
                    activeTab === "ambulance"
                      ? style.tab_heading
                      : style.heading_operation
                  }
                  text="Ambulance & Logistics"
                />
              </div>
            )}
            <Container className={style.chevron_wrapper}>
              <Icon
                src={isLogisticsOpen ? "/images/chevron-up.png" : "/images/chevron-down.png"}
                alt="chevron_icon"
              />
            </Container>
          </Flex>
        </Container>
        <div className={style.border}></div>

        {isLogisticsOpen && (
          <>
            <Container className={style.step}>
              <Button text="Completed :2/3" className={style.step_button} />
            </Container>

            {/* Tab Content */}
            {
              activeTab === "doctor" && isDoctorRequired && (
                <Container className={style.doctor_component}>
                  <div className={style.doctor_header}>
                    {getTicketMedicalStatus?.isAmbulanceRequired === "No" && (
                      <Button onClick={handleBookAmbulance} text={"Book Ambulance"} className={style.button} />
                    )}
                  </div>
                  <DoctorConsult />
                </Container>
              )
            }

            {
              activeTab === "ambulance" && isAmbulanceRequired && (
                <Ambulance
                  handleBookAmbulance={handleBookAmbulance}
                  pickupLocationLabel={pickupLocationLabel}
                  getTicketStatus={getTicketStatus}
                  handleCloseTicket={handleCloseTicket}
                  handleDemoCloseTicket={handleDemoCloseTicket}
                  getPatientPickupAddress={getPatientPickupAddress}
                  getPatientPickupCity={getPatientPickupCity}
                  getPatientDropLocation={getPatientDropLocation}

                />
              )
            }
          </>
        )}
      </Container >


      <Container>
        {/* <Button
          disable={getTicketStatus === "completed" ? true : false}
          className={`${getTicketStatus !== "completed" ? style.button : style.is_disabled
            }`}
          text="Emergency Resolved"
          onClick={handleCloseTicket}
        /> */}
        {
          getTicketStatus === "completed" && <Button
            disable={isTicketDemo}
            text="Demo"
            className={`${!isTicketDemo ? style.demo_button : style.demo_button_is_disabled}`}
            onClick={handleDemoCloseTicket}
          />
        }
      </Container>
      {/* ///step-2// */}
      {/* //doctor-consult && ambulance// */}

    </TicketBasicDetWrapper >
  );
};
